import { QRCodeSVG } from "qrcode.react";
import { useI18n } from "@/lib/i18n";

export const QrInstall = () => {
  const { t } = useI18n();
  const url = typeof window === "undefined" ? "" : window.location.origin;

  return (
    <div
      className="flex flex-col items-center gap-6 border border-[#C69A3B] bg-[#F6F0E4] p-6 sm:flex-row sm:p-8"
      data-testid="qr-install-card"
    >
      <div className="border border-[#C69A3B]/40 bg-white p-3" data-testid="qr-install-code">
        <QRCodeSVG value={url} size={132} level="M" bgColor="#FFFFFF" fgColor="#252525" />
      </div>
      <div className="text-center sm:text-left">
        <p className="label-mono">{t("qr.label")}</p>
        <p className="mt-3 font-serif-display text-xl text-[#8F3329] sm:text-2xl">{t("qr.title")}</p>
        <p className="mt-3 text-sm text-[#5A5752]">{t("qr.steps")}</p>
      </div>
    </div>
  );
};

export default QrInstall;
